import template from './auth.html';
import controller from './auth.controller';

let authComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller,
  controllerAs: 'vm'
};

export default authComponent;



// WEBPACK FOOTER //
// ./client/app/routes/auth/auth.component.js